import React, { Component } from 'react'
import cn from 'classnames'
import s from './Table.scss'
import sLay from 'styles/modules/layout.scss'

export default class Table extends Component {
  render() {
    const { header, children, style, className } = this.props
    return (
      <div className={cn(s.table, className)} style={style}>
        {header}
        <div className={cn(s.tableBody, sLay['layout-column'])}>{children}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Table/Table.jsx